var classes = {"root":"y1PCZ","tagVariantDefault":"XiOLU","tagVariantDiscontinued":"i6plJ","tagVariantFilled":"mni-b"};

export { classes as default };
